import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { TranslateModule } from '@ngx-translate/core';
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";
import { AccueilAvecAccesComponent } from "./accueil-avec-acces/accueil-avec-acces.component";
import { DocumentService } from "src/app/shared/services/document.service";

@Component({
    selector: 'app-accueil-intranet',
    templateUrl: './accueil-intranet.component.html',
    styleUrls: ['./accueil-intranet.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        AccueilAvecAccesComponent
    ]
})
export class AccueilIntranetComponent {
  #authService = inject(ZzzSecuriteService);

  estAuthentifie = this.#authService.utilisateurEstAuthentifie;
  constructor(
    private documentService: DocumentService
  ) { }

  @ViewChild('descPublic', { static: false }) paragraphDesc!: ElementRef<HTMLParagraphElement>;

  ngAfterViewInit() {
    this.paragraphDesc?.nativeElement?.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (target.closest('a.guideLink')) {
        e.preventDefault();
        this.openDocument('guide_Utilisateur_PGTP_Publique', e as MouseEvent);
      }
    });
  }
    openDocument(fileName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.documentService.getPdf(fileName).subscribe({
        next: blob => {
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 30000);
        },
        error: err => {
          console.error("Erreur inattendue", err);
        }
    });
  }
}
